import Vue from "vue";
import Vuex from "vuex";
import api from "@/services/api.js";
// Modules
import snackbar from "./modules/snackbar";
import events from "./modules/events";
import polls from "./modules/polls";
import timers from "./modules/timers";
import createPersistedState from "vuex-persistedstate";

let namespace = null;

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      key: "agmify-vuex",
      paths: ["namespace", "manager", "token", "timers", "activePoll"]
    })
  ],
  state: {
    namespace,
    token: "",
    onlineUsers: [],
    onlineManagers: {},
    activePollIds: [],
    loading: false,
    manager: null,
    user: null,
    proxies: [],
    poll: null
  },
  mutations: {
    SET_NAMESPACE(state, payload) {
      state.namespace = payload;
    },
    LOGOUT(state) {
      state.token = "";
      //localStorage.clear();
    },
    LOGIN(state, payload) {
      state.token = payload;
    },
    SET_MANAGER(state, payload) {
      state.manager = payload;
    },
    setUser(state, payload) {
      state.user = payload;
    },
    setScrutineer(state, payload) {
      state.user.scrutineer = payload;
    },
    setProxies(state, payload) {
      state.proxies = payload;
    },
    setPoll(state, payload) {
      state.poll = payload;
    },

    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SOCKET_ONLINE_USERS(state, payload) {
      state.onlineUsers = payload;
    },
    SOCKET_ONLINE_MANAGERS(state, payload) {
      //console.log('MANAGERS: ', payload);
      state.onlineManagers = payload;
    },
    SOCKET_ACTIVE_POLL_IDS(state, payload) {
      //console.log('ACTIVE POLLS:', payload);
      state.activePollIds = payload;
    },
    SET_ONLINE_USERS(state, payload) {
      state.onlineUsers = payload;
    }
  },
  actions: {
    async initializeApp({ state, rootState, commit, dispatch }) {
      try {
        commit("SET_LOADING", true);

        if (state.namespace) {
          const eventId = state.namespace;
          await dispatch("loadEvent", eventId);
        }
        await dispatch("loadEvents");

        this._vm.$socket.client.open();
        this._vm.$socket.client.on("connect", () => {
          this._vm.$socket.client.emit("JOIN_MANAGERS", state.manager);
          console.log("Admin Connecting");
        });
        this._vm.$socket.client.on("reconnect", () => {
          console.log("Admin Reconnecting");
        });
        this._vm.$socket.client.on("disconnect", () => {
          console.log("Admin Disconnecting");
        });
        commit("SET_LOADING", false);
      } catch (err) {
        console.log("App Init Error", err);
        commit("SET_LOADING", false);
      }
    },

    async logout({ commit }) {
      this._vm.$socket.client.emit("disconnect");
      this._vm.$socket.client.disconnect();
      commit("LOGOUT"); // resets token to empty
    }
  },
  modules: {
    snackbar,
    events,
    polls,
    timers
  }
});
